import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as license from "../../../../constants/license";
import * as globalActions from "../../../../actions/globalActions";
import * as licenseActions from "../../../../actions/licenseActions";
import * as messageHelper from "../../../../helpers/messageHelper";
import * as formatHelper from "../../../../helpers/formatHelper";

import Button, {BUTTON_SMALL} from "../../../global/generic/Button";
import LicenseVersion from "../../../global/service/LicenseVersion";

import imgLicense from "../../../../resources/img/svgicons/license-to-expire.svg";
import imgLoader from "../../../../resources/img/loader.svg";
import imgWarningError from "../../../../resources/img/svgicons/warning.svg";
import imgCheck from "../../../../resources/img/svgicons/check-circle.svg";
import imgSkip from "../../../../resources/img/svgicons/skip.svg";
import imgNewLicense from "../../../../resources/img/svgicons/reactive.svg";

class LicenseMessage extends Component {
    handleContinueToActivateLicenseClick = () => {
        this.props.dispatchIsOnlineActivationAvailableAction();
    };

    handleContinueToRedlikeClick = () => {
        this.props.dispatchStartSoftwareInitializationAction();
    };

    getLicenseVersion = () => {
        if (
            this.props.licenseStatus === license.STATUS_VALID_UNLIMITED_LICENSE ||
            this.props.licenseStatus === license.STATUS_VALID_LEASED_LICENSE
        ) {
            return <LicenseVersion />;
        }

        return "";
    };

    getLicenseExpirationMessage = (dayCount) => {
        if (dayCount === 1) {
            return <Translate value="license.licenseWillExpireOneDay" dayCount={dayCount} />;
        }

        return <Translate value="license.licenseWillExpire" dayCount={dayCount} />;
    };

    getLicenseWarningMessage = () => {
        if (this.props.licenseStatus === license.STATUS_VALID_UNLIMITED_LICENSE) {
            return (
                <div className="license-already-activated">
                    <ReactSVG src={imgCheck} className="svg-icon license-activated-icon" alt="license-activated" />
                    <Translate value="license.licenseActivated" />
                </div>
            );
        }

        if (
            this.props.licenseStatus === license.STATUS_VALID_LEASED_LICENSE ||
            this.props.licenseStatus === license.STATUS_VALID_PROLONGATED_LICENSE
        ) {
            return (
                <div className="license-expires-in">
                    <ReactSVG src={imgLicense} className="svg-icon" alt="license-expire" />
                    <div>
                        <Translate
                            value="license.expirationDate"
                            dateTime={formatHelper.formatDateTimeUtc(this.props.licenseExpiration)}
                        />
                        {this.getLicenseExpirationMessage(Math.floor(this.props.licenseRemaining / 3600 / 24))}
                    </div>
                </div>
            );
        }

        return (
            <div className="license-expires-in">
                <ReactSVG src={imgWarningError} className="svg-icon" alt="license-expire" />
                {messageHelper.getInvalidLicenseMessage(this.props.errorCode, "License error")}
            </div>
        );
    };

    getContinueToActivateLicenseButton = () => {
        if (this.props.errorCode === license.DELETED_LICENSE) {
            return "";
        }

        if (this.props.loading) {
            return <img alt="loader" src={imgLoader} />;
        }

        let label = [
            license.STATUS_VALID_UNLIMITED_LICENSE,
            license.STATUS_VALID_LEASED_LICENSE,
            license.STATUS_VALID_PROLONGATED_LICENSE
        ].includes(this.props.licenseStatus)
            ? "license.reactivateLicense"
            : "license.activateLicense";

        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value={label} />}
                svgBefore={imgNewLicense}
                onClick={this.handleContinueToActivateLicenseClick}
            />
        );
    };

    getSkipNewLicenseButton = () => {
        if (
            this.props.setupSoftware ||
            this.props.licenseStatus === license.STATUS_ERROR ||
            this.props.licenseStatus === license.STATUS_UNKNOWN
        ) {
            return "";
        }

        return (
            <Button
                size={BUTTON_SMALL}
                label={<Translate value="general.skip" />}
                svgBefore={imgSkip}
                onClick={this.handleContinueToRedlikeClick}
            />
        );
    };

    render() {
        if (this.props.setupSoftware) {
            return (
                <React.Fragment>
                    <div className="row form-box-dark-blue license-text">
                        <div className="col-xs-12">
                            {this.getLicenseVersion()}
                            <div className="row">
                                <div className="col-xs-12">{this.getLicenseWarningMessage()}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 flex flex-align-center flex-gap-3vh">
                        {this.getContinueToActivateLicenseButton()}
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <div className="form-box-dark-blue row">
                    <div className="col-xs-12 license-text text-center">{this.getLicenseWarningMessage()}</div>
                </div>
                <div className="col-12 flex flex-align-center flex-gap-3vh margin-bottom-10">
                    {this.getContinueToActivateLicenseButton()}
                    {this.getSkipNewLicenseButton()}
                </div>
            </React.Fragment>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        setupSoftware: store.module.setupSoftware,
        licenseStatus: store.license.licenseStatus,
        licenseRemaining: store.license.licenseRemaining,
        licenseExpiration: store.license.licenseExpiration,
        errorCode: store.license.errorCode,
        loading: store.server.requests.length > 0
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartSoftwareInitializationAction: () => {
            dispatch(globalActions.startSoftwareInitialization());
        },
        dispatchIsOnlineActivationAvailableAction: () => {
            dispatch(licenseActions.isOnlineActivationAvailableForWizard());
        }
    };
};

export default LicenseMessage = connect(mapStoreToProps, mapDispatchToProps)(LicenseMessage);
